import { useAppSelector } from 'app/hooks';
import { License } from 'common/types/Entities';
import { selectLicenses } from 'features/licenses/licensesSlice';
import { useFetchLicensesByTenantId } from 'features/reports/hooks/useFetchLicensesByTenantId';

import { MultiSelectDropdown } from './MultiSelectDropdown';

export function LicensesMultipleSelectDropDown(props: Readonly<{
        tenantId: string,
        value: License[],
        onChange: (licenses: License[]) => void,
    }>) {
    const { tenantId, value, onChange } = props;
    const licenses = useAppSelector(selectLicenses);

    useFetchLicensesByTenantId(onChange, tenantId);

    return (
        <MultiSelectDropdown
            disabled={!tenantId}
            value={value}
            onChange={onChange}
            options={licenses}
            getOptionLabel={opt => opt.billingSystemName + ' - ' + opt.billingRecord}
            label="Licenses"
            noOptionsText="Licenses not found"
        />
    );
}
